import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es/translation.json";
import en from "./locales/en/translation.json";
import ca from "./locales/ca/translation.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			es: { translation: es },
			en: { translation: en },
			ca: { translation: ca },
		},
		supportedLngs: ["es", "en", "ca"],
		fallbackLng: {
			default: ["es"], // 👈 por defecto, español
			ca: ["es"], // 👈 si falta algo en catalán → usa español
			en: ["es"], // opcional: si falta algo en inglés → usa español
		},
		nonExplicitSupportedLngs: true,
		detection: {
			order: ["navigator", "querystring", "localStorage"],
			caches: ["localStorage"],
			lookupQuerystring: "lng",
			lookupLocalStorage: "i18nextLng",
		},
		interpolation: { escapeValue: false },
		initImmediate: false,
	});

console.log("Idioma detectado:", i18n.language);

export default i18n;
